<template>
 <div class="">
    <div  v-if="!isAdmin" class="alert alert-warning my-3" role="alert" >Please log in as an administrator!</div>
    <div v-else class="container">
       <table class="table table-striped table-sortable table-sm fs-xs">
        <thead>
          <tr>
            <th @click="sortBy('type')" :aria-sort="sortKey==='type'?sortOrder:''" class="sortable ps-4">
              Id 
            </th>
            <th @click="sortBy('status')"  :aria-sort="sortKey==='status'?sortOrder:''" class="sortable ps-4">
              Status 
              
            </th>
            <th @click="sortBy('startTimeEpoch')" :aria-sort="sortKey==='startTimeEpoch'?sortOrder:''" class="sortable ps-4">
              StartTime 
             
            </th>
            <th @click="sortBy('endTimeEpoch')" :aria-sort="sortKey==='endTimeEpoch'?sortOrder:''" class="sortable ps-4">
              EndTime 
             
            </th>
            <th @click="sortBy('runId')" :aria-sort="sortKey==='runId'?sortOrder:''" class="sortable ps-4">
              runId 
              
            </th>
            <th @click="sortBy('info')" :aria-sort="sortKey==='info'?sortOrder:''" class="sortable ps-4">
              Info 
             
            </th>
            <th @click="sortBy('runInfo')" :aria-sort="sortKey==='runInfo'?sortOrder:''" class="sortable ps-4">
              runInfo 
             
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="loader in sortedLoaderStatus" :class="{ error: isError(loader), old: isOld(loader) }">
            <td>
              <i v-if="isError(loader) || isOld(loader)" class="bi bi-exclamation-diamond"></i> {{loader.type}}
            </td>
           <td>
              {{loader.status}}
            </td>
            <td>
              {{formatDateTime(loader.startTimeEpoch)}}
            </td>
            <td>
              {{formatDateTime(loader.endTimeEpoch)}}
            </td>
            <td>
              {{loader.runId}}
            </td>
            <td>
              {{loader.info}}
            </td>
            <td>
              {{loader.runInfo}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <CommonModals />
  </div>
</template>

<script>
import "/src/visualcrossing-core/vccommunicator_serveradmin";
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import CommonModals from '/src/components/CommonModals.vue';
import '/src/website-core/VcUtils';
export default {
  name: 'loadermonitor',
  props: {
    
  },
  data() {
    return {
     
      sessionId:null,
      sessionState:null,
      loaderstatus:null,
      lastrefresh:0,
      refreshinterval:10,
      enableautorefresh:true,
      sortKey: 'type',
      sortOrder: 'asc'
    }
  },
  methods:{
    isError(loader) {
      var me=this;
      return !loader || (loader.status!=='success' && loader.status!=='aborted_no_data');
    },
    isOld(loader) {
      var me=this;
      if (!loader || !loader.endTimeEpoch) return false;
      return (+loader.endTimeEpoch)<(me.getTime()/1000-86400)
    },
    getTime:function() {
        return new Date().getTime();
    },
    formatDateTime(epochSecs) {
      return VcDateUtils.formatDateTime2(epochSecs,null, {
        year:'numeric',
        month: 'long', 
        day:'numeric',
        hour: 'numeric', 
        minute: 'numeric',  
        hour12: false
        
      })
    },
    refreshLoaderStatus:function() {
      var me=this;
      if (!me.isAdmin) return;
      

      vcCommunicator.loaderstatus() //
        .then(function (results) {
          me.loaderstatus=results;
          me.lastloaderrefresh=me.getTime();
        
        })
        .catch((error) => {
          console.log(error);
          me.loaderstatus=null;
        });

        if (me.enableautorefresh) {
          setTimeout(function() {
            me.refreshLoaderStatus()
          }, me.refreshinterval*1000);
        }
     
      },
      sortBy(key) {
        this.sortKey = key;
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      },
      getSortIcon(key) {
        if (this.sortKey !== key) return 'sort-down-alt';
        return this.sortOrder === 'asc' ? 'bi-sort-up' : 'bi-sort-down';
      }
  },
  computed:{
    isAdmin() {
      let me=this;
      return me.sessionState && me.sessionState.contextProperties &&  me.sessionState.contextProperties.isAdmin==="true";
    },
    sortedLoaderStatus() {
      const order = this.sortOrder === 'asc' ? 1 : -1;
      return this.loaderstatus ? [...this.loaderstatus].sort((a, b) => {
        if (a[this.sortKey] < b[this.sortKey]) return -order;
        if (a[this.sortKey] > b[this.sortKey]) return order;
        return 0;
      }) : [];
    }
  },
  watch: {

  },
   unmounted() {
    var me=this;
  },
  mounted() {
     var me=this;
   
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
      me.refreshLoaderStatus();
    
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
       me.sessionState=null;
    });

    me.refreshLoaderStatus();
    
    
  },
  components: {
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .old {
      font-style: italic;
      opacity: 0.9;
  }
  .table-striped tbody  .error {
    font-weight: bold;
  
  }
  .table-striped tbody .error td {
      background-color: rgb(245, 212, 212) !important;
  }

  /* Arrows */

.table-sortable th,
.table-sortable td {
  padding: 1em 0.5em;
  position: relative;
}

.table-sortable th {
  font: 400 1.25em/1 'Oswald', sans-serif;
  letter-spacing: 0.025em;
  outline: none;
  padding-right: 2em;
  text-align: left;
  text-transform: uppercase;
  transition: color 0.2s ease-in-out;
}

.table-sortable th:hover,
.table-sortable th:focus {
  color: #83e4e2;
}

/* Arrows */
.table-sortable th:after,
.table-sortable th:before {
  border: 0.35em solid transparent;
  content: '';
  height: 0; 
  position: absolute;
  left: 0.65em;
  top: 50%;
  transform: translateY(-50%);
  transition: border-color 0.2s ease-in-out;
  width: 0; 
}

.table-sortable th:before {
  border-bottom-color: #d5d2dc;
  border-top: 0;
  margin-top: -0.35em;
}

.table-sortable th:after {
  border-bottom: 0;
  border-top-color: #d5d2dc;
  margin-top: 0.35em;
}

.table-sortable th:hover:before,
.table-sortable th:focus:before {
  border-bottom-color: #aeacb3;;
}

.table-sortable th:hover:after,
.table-sortable th:focus:after {
  border-top-color: #aeacb3;
}

.table-sortable th[aria-sort="asc"],
.table-sortable th[aria-sort="desc"] {
  color: #fddc32;
}

.table-sortable th[aria-sort="asc"]:before {
  border-bottom-color: #00628b;
}

.table-sortable th[aria-sort="asc"]:after {
  border-top-color: #86848a;
}

.table-sortable th[aria-sort="desc"]:before {
  border-bottom-color: #86848a;
}

.table-sortable th[aria-sort="desc"]:after {
  border-top-color: #00628b;
}

</style>